"use client";

import { useState } from "react";

import { Bar } from "@/app/(marketing)/components/demo/bar/Bar";
import { ConversionShowcase } from "@/app/(marketing)/components/demo/showcases/conversionShowcase/components/ConversionShowcase";
import { HarmonyMakerShowcase } from "@/app/(marketing)/components/demo/showcases/HarmonyMakerShowcase";
import { IsolateShowcase } from "@/app/(marketing)/components/demo/showcases/IsolateShowcase";
import { MixShowcase } from "@/app/(marketing)/components/demo/showcases/MixShowcase";
import { StemSplitterShowcase } from "@/app/(marketing)/components/demo/showcases/StemSplitterShowcase";
import { TrainVoiceShowcase } from "@/app/(marketing)/components/demo/showcases/TrainVoiceShowcase";
import { DemoOption } from "@/types/types";
import { cn } from "@/utils/cn";

export function Demo({ className }: { className?: string }) {
  const [chosenOption, setChosenOption] = useState<DemoOption>("convert");

  const setChosenOptionWithTransition = (option: DemoOption) => {
    if (typeof document.startViewTransition === "function") {
      document.startViewTransition(() => {
        setChosenOption(option);
      });
    } else {
      // Fallback for browsers that don't support View Transitions API
      setChosenOption(option);
    }
  };

  return (
    <div className={cn("mx-auto max-w-6xl px-4 lg:px-8", className)}>
      <Bar
        chosenOption={chosenOption}
        setChosenOption={setChosenOptionWithTransition}
      />
      <div className="mt-3">
        {chosenOption === "convert" && <ConversionShowcase />}
        {chosenOption === "train" && <TrainVoiceShowcase />}
        {chosenOption === "isolate" && <IsolateShowcase />}
        {chosenOption === "mix" && <MixShowcase />}
        {chosenOption === "harmony" && <HarmonyMakerShowcase />}
        {chosenOption === "stem" && <StemSplitterShowcase />}
      </div>
    </div>
  );
}
